<template>
  <div class="page">
    <box fill>
      <el-form label-position="right" label-width="80px" class="EL-Form">
        <el-col :lg="5" :xl="5">
          <el-form-item label="库位编号" class="EL-Form-Item">
            <el-input
              placeholder="请输入" v-model="searchInfo.lcCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="searchInfo.matCode">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料类型" class="EL-Form-Item">
            <el-select v-model="searchInfo.mtType" placeholder="请选择" filterable clearable="clearable" multiple collapse-tags>
              <el-option v-for="(item, index) in mtTypeList" :key="index" :label="item.ddCode+' - '+item.ddName" :value="item.ddCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
					<el-form-item label="供应商" class="EL-Form-Item">
						<el-select v-model="searchInfo.verdorCode" placeholder="请选择" filterable clearable="clearable">
              <el-option v-for="(item, index) in vendorList" :key="index" :label="item.svCode + ' - ' + item.vendorName" :value="item.svCode">
              </el-option>
            </el-select>
					</el-form-item>
				</el-col>
        <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="开始日期" class="EL-Form-Item">
            <el-date-picker v-model="searchInfo.beginTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" default-time="00:00:00" placeholder="开始日期"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="结束日期" class="EL-Form-Item">
            <el-date-picker v-model="searchInfo.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" default-time="23:59:59" placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </el-col> -->
        <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getMainData()">
              查询
            </el-button>
            <el-button class="btn-t-delete" @click="resetData()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
					<el-form-item label="入库时间" class="EL-Form-Item">
            <el-date-picker style="width: 350px" v-model="searchInfo.date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
          </el-form-item>
				</el-col>
      </el-form>
      <el-divider></el-divider>
      <plabel text="原材料入库报表">
        <el-button
          v-authority="'BACK_MENU7_M1_B1'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >
      </plabel>
      <!-- 展示 -->
      <h-table ref="tableRef" :summary-method="getSummaries" show-summary :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getMainData" :data="mainData" pagination
        :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total"
      >
        <!-- <el-table-column prop="wxId" label="序号" /> -->
        <el-table-column prop="fcCode" label="工厂编号" />
        <el-table-column prop="whCode" label="通道编号" />
        <el-table-column prop="laCode" label="库位编号" />
        <el-table-column prop="matCode" label="物料编号" />
        <el-table-column prop="mtType" label="物料类型" />
        <el-table-column prop="batchNo" label="批次号" />
        <el-table-column prop="verdorCode" label="供应商编码" />
        <el-table-column prop="createTime" label="入库时间" />
        <el-table-column prop="boxBarcodeCount" label="箱数" />
        <el-table-column prop="matQuan" label="入库总数量" />
        <el-table-column prop="matQuan10" label="采购入库数量" />
<!--        <el-table-column prop="matQuan20" label="外协入库数量" />
        <el-table-column prop="matQuan30" label="退料入库数量" />-->
<!--        <el-table-column prop="matQuan40" label="其他仓库入库数量" />-->
      </h-table>
    </box>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: "writeXaIn",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        total: 0
      },
			searchInfo: {
        matCode: "",
        lcCode: "",
        // batchNo: "",
        fcCode: localStorage.getItem("fcCode") || "",
        // person: localStorage.getItem("user"),
        // beginTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
        // endTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
				date: [],
        mtType: [],
        verdorCode: "",
			},
      taskTab: "0",

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,
      mtTypeList: [],
      vendorList: []
    };
  },
  updated(){
    this.$nextTick(() => {
      this.$refs.tableRef.$refs.table.doLayout()
    })
  },
  watch: {
    searchInfo: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getMainData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  methods: {
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getMainData();
      }, 1000);
    },
    //获取数据
    getMainData() {
      this.$http
        .request({
          url: "/api/xa/getXaByIn",
          method: "GET",
          params: {
						fcCode: this.searchInfo.fcCode || null,
						matCode: this.searchInfo.matCode || null,
						lcCode: this.searchInfo.lcCode || null,
						// batchNo: this.searchInfo.batchNo || null,
						// person: this.searchInfo.person || null,
						pageNum: this.pagination.pageNum,
						pageSize: this.pagination.pageSize,
						beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
						endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
            mtType: this.searchInfo.mtType.join(",") || null,
            verdorCode: this.searchInfo.verdorCode || null,
					},
        })
        .then((resp) => {
          this.loading--;
          if (resp.status == 100) {
            this.mainData = resp.data.list || [];
            this.pagination.total = resp.data.total;
          }
          this.$nextTick(() => {
            this.$refs.tableRef.$refs.table.doLayout();
          })
        })
        .catch((error) => {
          this.loading--;
        });
    },
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
        if (index === 0) {
            sums[index] = '合计';
            return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) && (column.property == "boxBarcodeCount" ||  column.property == "matQuan" || column.property == "matQuan10" ||column.property == "matQuan20" ||column.property == "matQuan30" ||column.property == "matQuan40")) {
            sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
                return prev + curr;
            } else {
                return prev;
            }
            }, 0);
            sums[index];
        }
        });

        return sums;
    },
    //重置
    resetData() {
      this.pagination = {
        pageNum: 1,
        pageSize: 50,
        total: 0
      };
			this.searchInfo = {
        matCode: "",
        lcCode: "",
        // batchNo: "",
        fcCode: localStorage.getItem("fcCode") || "",
        // person: localStorage.getItem("user"),
        // beginTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
        // endTime: moment().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
				date: [],
        mtType: [],
        verdorCode: "",
			}
			//添加默认时间
			this.searchInfo.date.push(moment().format("YYYY-MM-DD")+ ' 00:00:00');
			this.searchInfo.date.push(moment().format("YYYY-MM-DD")+ ' 23:59:59');
      // this.getMainData();
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
				fcCode: this.searchInfo.fcCode || null,
        matCode: this.searchInfo.matCode || null,
        lcCode: this.searchInfo.lcCode || null,
        // batchNo: this.searchInfo.batchNo || null,
        // person: this.searchInfo.person || null,
				beginTime: this.searchInfo.date ? this.searchInfo.date[0] : null,
				endTime: this.searchInfo.date ? this.searchInfo.date[1] : null,
        pageNum: 1,
        pageSize: 999999,
        mtType: this.searchInfo.mtType.join(",") || null,
        verdorCode: this.searchInfo.verdorCode || null,
      };

      this.$http
        .request({
          url: "/api/xa/getXaByIn",
          method: "GET",
          showLoading: true,
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        const tHeader = [
          "工厂编号",
          "通道编号",
          "库位编号",
          "物料编号",
          "物料类型",
          "批次号",
          "供应商编码",
          "入库时间",
          "箱数",
          "入库总数量",
          "采购入库数量",
          // "外协入库数量",
          // "退料入库数量",
          // "其他仓库入库数量"
        ];

        const filterVal = [
          "fcCode",
          "whCode",
          "laCode",
          "matCode",
          "mtType",
          "batchNo",
          "verdorCode",
          "createTime",
          "boxBarcodeCount",
          "matQuan",
					"matQuan10",
          // "matQuan20",
          // "matQuan30",
          // "matQuan40"
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "原材料入库报表数据",
        });
        this.logContent = "导出";
        this.logRemarks = "write_xa：导出原材料入库报表数据";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "原材料入库报表",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
    //获取类型
    getmtTypeList() {
      this.$http.request({
        url: "/api/dictData/getDictData",
        method: "GET",
        showLoading: true,
        params: {
          ddCode: "MDTYPE",
        },
      }).then((resp) => {
        if (resp.status == 100) {
          this.mtTypeList = resp.data.list || [];
        }
      }).catch((error) => { });
    },
    async getVerdorList() {
			try {
				const res = await this.$http.request({
					url: "/api/vendor/getVendorAll",
					method: "GET",
					showLoading: true,
					params: {
						pageNum: 1,
						pageSize: 999999,
					},
				})
				if (res.status == 100) {
					this.vendorList = res.data.list
				} else {
					this.vendorList = []
				}
			} catch (error) {
				this.vendorList = []
			}
		},
  },
  activated() {
    //添加默认时间
    this.searchInfo.date = [];
    this.searchInfo.date.push(moment().format("YYYY-MM-DD")+ ' 00:00:00');
    this.searchInfo.date.push(moment().format("YYYY-MM-DD")+ ' 23:59:59');

    /* 获取首页的数据 */
    // this.getMainData();

    this.getmtTypeList()
    this.getVerdorList()
  },
};
</script>

<style scoped>
</style>
